
<c-app-panel
    v-if           = "items.length > 0"
    :icon          = "counts.active > 0 ? 'mdi-upload' : counts.failed > 0 ? 'mdi-alert-circle' : 'mdi-check-circle'"
    :icon-color    = "counts.failed > 0 && counts.active === 0 ? 'error' : 'primary'"
    :title         = "title"
    :progress      = "overall"
    :progress-color = "counts.failed > 0 ? 'warning' : 'primary'"
    collapsible
    :close-disabled = "counts.active > 0"
    @close         = "onClose"
>
    <div class="upload-content">
        <div v-for="item in uploading" :key="item.key" class="upload-item">
            <div class="upload-name">{{ item.file.name }}</div>
            <div class="upload-where">{{ item.siteLabel }} / {{ item.folderLabel }}</div>
            <v-progress-linear :value="item.progress * 100" height="6" color="primary" rounded />
        </div>

        <div v-if="counts.active > 0" class="upload-summary">
            <span v-if="waiting > 0">{{ $t('img.upload.waiting', { n: waiting }) }}</span>
            <span v-if="processing > 0">{{ $t('img.upload.processing', { n: processing }) }}</span>
        </div>

        <div v-for="item in skipped" :key="item.key" class="upload-item">
            <div class="upload-name">{{ item.file.name }}</div>
            <div class="upload-where">
                {{ item.siteLabel }} / {{ item.folderLabel }} · {{ $t('img.upload.skipped') }}
            </div>
        </div>

        <div v-if="retryableCount > 1 && counts.active === 0" class="upload-retry-all">
            <v-btn x-small text color="primary" @click="Uploads.retryAll()">
                <v-icon left x-small>mdi-reload</v-icon>
                {{ $t('img.upload.retryAll') }}
            </v-btn>
        </div>

        <div v-for="item in failed" :key="item.key" class="upload-item">
            <div class="upload-name error--text">{{ item.file.name }}</div>
            <div class="upload-where">
                {{ item.siteLabel }} / {{ item.folderLabel }} · {{ reason(item) }}
                <a v-if="retryable(item)" class="ml-1" @click="Uploads.retry(item)">{{ $t('img.upload.retry') }}</a>
            </div>
        </div>
    </div>
</c-app-panel>
